import type { Fallacy } from "./types";
import { createStory } from "./types";

export const appealToAuthority: Fallacy = {
    id: "appeal-to-authority",
    name: "Appeal to Authority",
    emoji: "👑",
    category: "Argumen Lemah",
    description:
      "Menggunakan **pendapat tokoh terkenal** sebagai bukti kebenaran, padahal tokoh tersebut **bukan ahli** di bidangnya.",
    detail:
      "Appeal to Authority terjadi ketika seseorang menggunakan **status atau popularitas seseorang** sebagai pengganti **bukti yang valid**.\n\nMengutip ahli di bidangnya itu BUKAN fallacy. Yang jadi fallacy adalah ketika:\n• Tokoh yang dikutip bukan ahli di bidang tersebut\n• Pendapat tokoh dijadikan kebenaran mutlak tanpa bukti pendukung\n• Jumlah followers dijadikan ukuran kebenaran\n\n**Kebenaran tidak ditentukan oleh siapa yang bilang**, tapi oleh bukti dan data yang mendukung. Cara mengenali: Tanyakan — apakah orang ini memang ahli di bidang yang dibahas? Apakah ada data yang mendukung klaimnya?",
    tldr: "Dia terkenal, bukan berarti dia bener. Cek dulu bidang keahliannya.",
    story: createStory("Appeal to Authority", "👑", {
      hook: {
        title: "\"Artis X aja bilang gitu!\"",
        body: "Tapi tunggu — emang dia **ahli di bidang itu**? Terkenal bukan berarti bener.",
      },
      convo: {
        claim: "Tapi ustadz viral bilang vaksin bahaya. **Masa jutaan followers-nya salah?** Dia kan public figure!",
        response: "Followers banyak **bukan bukti kebenaran.** Yang penting datanya, bukan siapa yang ngomong.",
      },
      reveal: {
        body: "Kamu pake **status atau popularitas seseorang** sebagai pengganti bukti. Padahal **kebenaran gak ditentukan oleh siapa yang ngomong**.",
      },
      insight: {
        title: "Kunci sederhananya?",
        body: "Terkenal dan ahli itu **beda**. Followers banyak bukan bukti kebenaran — yang penting **datanya**, bukan siapa yang ngomong.",
      },
      engagement: {
        title: "Paling sering nemu Appeal to Authority di mana?",
        body: "Endorse artis atau ceramah ustadz viral? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["bandwagon", "appeal-to-emotion", "appeal-to-nature"],
  };
